<script setup>
import { pageTransition } from '~/helpers/animations/animations';

definePageMeta({
  pageTransition: pageTransition,
});

const { t } = useI18n();
const route = useRoute();

const pageQuery = gql`
  query GetPageData($routeId: String!) {
    page(route_id: $routeId) {
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      name
      content
    }
    documents(types: "bulletin") {
      name
      file {
        url
      }
    }
  }
`;

const { data } = await useAsyncQuery(pageQuery, {
  routeId: route.name,
});

const page = computed(() => data.value?.page);
const documents = computed(() => data.value?.documents);

useHeadData({
  title: page.value?.seo_meta_title || page.value?.name || t('pages.funds.index.breadcrumbs-title'),
  description: page.value?.seo_meta_description || null,
  keywords: page.value?.seo_meta_keywords || null,
  image: page.value?.image || page.value?.cropped_detail_image || null,
  url: route.fullPath,
});

// import { page } from '~/mixins/transitions.js'
// import gql from 'graphql-tag'

// import Breadcrumbs from '~/components/Breadcrumbs.vue'
// import DynamicPageContent from '~/components/DynamicPageContent.vue'
// import LinkList from '~/components/LinkList.vue'
// import LinkListItem from '~/components/LinkListItem.vue'

// export default {
//   components: {
//     Breadcrumbs,
//     DynamicPageContent,
//     LinkList,
//     LinkListItem,
//   },
//   mixins: [page],
//   apollo: {
//     page: {
//       query: gql`
//         query($routeId: String!) {
//           page(route_id: $routeId) {
//             seo_meta_title
//             seo_meta_description
//             seo_meta_keywords
//             name
//             content
//           }
//         }
//       `,
//       variables() {
//         return {
//           routeId: this.$route.name,
//         }
//       },
//     },
//     documents: {
//       query: gql`
//         query {
//           documents(types: "bulletin") {
//             name
//             file {
//               url
//             }
//           }
//         }
//       `,
//     },
//   },
//   computed: {
//     breadcrumbs() {
//       return this.page && this.page.breadcrumbs
//         ? [...this.page.breadcrumbs].map((x, key) => ({
//             title: x.name,
//             route: key + 1 == this.page.breadcrumbs.length ? null : this.checkAboutPageRoute(x),
//           }))
//         : []
//     },
//   },
//   methods: {
//     checkAboutPageRoute(route) {
//       if (route.slug[this.$i18n.locale] == this.$route.params.slug) {
//         return null
//       } else if(route.route_id == null) {
//         return this.getRoute(route, this.page.breadcrumbs[0].route_id)
//       } else {
//         return this.getRoute(route).name
//       }
//     },
//   },
//   head() {
//     let title = this.page ? (this.page.seo_meta_title ? this.page.seo_meta_title : this.page.name) : null
//     let description = this.page && this.page.seo_meta_description ? this.page.seo_meta_description : null
//     let keywords = this.page && this.page.seo_meta_keywords ? this.page.seo_meta_keywords : null

//     return this.setHead(title, description, keywords)
//   },
// }
</script>

<template>
  <main v-if="page && documents" class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <h1 class="heading">{{ page.name }}</h1>

    <DynamicPageContent v-if="page.content" :content="page.content" class="mt-5" />

    <div v-if="documents.length" class="mt-5">
      <h2 class="heading heading--2 heading--thin">
        {{ t('pages.bulletin.archive') }}
      </h2>

      <LinkList class="mt-3">
        <LinkListItem v-for="(item, key) in documents" :key="key" :link="item.file.url">
          {{ item.name }}
        </LinkListItem>
      </LinkList>
    </div>
  </main>
</template>
